import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { segmentAnalytics, SegmentTrackerEventCompTool } from '@roc/feature-utils';
import { useStore } from '@roc/client-portal-shared/hooks';
import { CompPropertyCard } from './compPropertyCard';
import { useState } from 'react';
import PropertyViewModal from './propertyViewModal';



export const CompsCardView = observer(() => {
  const { compToolStoreV2: compToolStore } = useStore();
  const { compToolFeedbackStore } = compToolStore;
  const { subjectProperty, isInternal, internalUsername, userStore } = compToolStore;
  const manuallyAddedComparableProperties = compToolStore.manuallyAddedComparables || [];
  const properties = [
    ...manuallyAddedComparableProperties,
    ...(compToolStore.compResponse.properties || [])
  ];



  const [openViewModal, setOpenViewModal] = useState(false);

  const openDialog = (property) => {
    compToolStore.setSelectedProperty(property);
    setOpenViewModal(true);
    compToolFeedbackStore.reset();
    segmentAnalytics.trackEvent({
      name: SegmentTrackerEventCompTool.COMP_TOOL_COMP_PROPERTY_CLICKED,
      userName: isInternal ? internalUsername : userStore.userInformation?.username,
      subjectAddress: subjectProperty.data.address,
      propertyAddress: property.data.address
    });
  }

  return (
    <Grid container spacing={2}>
      {
        properties.map(property =>
          <Grid key={property.property_id} item xs={12} sm={compToolStore.propertiesMapExtended ? 3 : 6}>
            <CompPropertyCard
              subjectProperty={subjectProperty}
              property={property}
              displayRentalInfo={compToolStore.rentalComps}
              savedProperty={compToolStore.savedPropertyComps?.some(p => p.comparePropertyId === property.property_id)}
              checked={compToolStore.selectedCompareProperties?.some(p => p.property_id === property.property_id)}
              onSelect={openDialog}
              onCheck={() => { compToolStore.addSelectCompareProperties(property) }} />

          </Grid>
        )
      }
      <PropertyViewModal open={openViewModal} property={compToolStore.selectedProperty} onClose={() => setOpenViewModal(false)} />
    </Grid>
  );
});
